import CustomView from "../custom-view/custom-view";
import PersonalView from "../view/personal-view/personal-view";
import {SpaceProto} from "../space/space-proto";

export enum NavigationSectionType {

    NAVIGATION          = 'navigation',
    NAVIGATION_PANEL    = 'navigation-panel',

    HOME                = 'home',

    // DEPRICATED USE (!)
    HOME_MENU           = 'my-work', // this is OLD from ViewLocation.HOME_MENU='my-work not usre if we have it in DB but i'll keep support for now

    PROJECTS            = 'projects',
    WORKSPACE           = 'workspace',

    GOALS               = 'goals',
    TOOLS               = 'tools',
    CHATS               = 'chats',
    USERS               = 'users',
    SETTINGS            = 'settings',
    HELP                = 'help',
    MY_ACCOUNT          = 'my-account',
    SEARCH              = 'search',
    QUICK_ADD           = 'quick-add',
    SEPARATOR           = 'separator',
    MORE                = 'more',
    ATTENDANCE          = 'my-attendance',
    CRM                 = 'crm',
    REPORTS             = 'reports',

    CUSTOM_VIEW         = 'custom-view',
    PERSONAL_VIEW       = 'personal-view',

    AI_CHAT             = 'ai-chat',
}

export enum NavigationButtonPosition {
    TOP         = 'top', // left in horizontal menu
    BOTTOM      = 'bottom', // right in horizontal menu
    MORE        = 'more', // hide from nav panel into more ?
    STATIC      = 'static', // like settings
}

export const NavigationButtonPositionDictionary : DictionaryStringString = {
    [NavigationButtonPosition.TOP]         : 'Navigation Panel', // left in horizontal menu
    [NavigationButtonPosition.BOTTOM]      : 'Navigation Panel', // right in horizontal menu
    [NavigationButtonPosition.MORE]        : 'More', // hide from nav panel into more ?
    [NavigationButtonPosition.STATIC]      : 'static', // like settings
}

export const NavigationButtonPositionIcon : DictionaryStringString = {
    [NavigationButtonPosition.TOP]         : 'i5-panel', // left in horizontal menu
    [NavigationButtonPosition.BOTTOM]      : 'i5-panel', // right in horizontal menu
    [NavigationButtonPosition.MORE]        : 'i5-more-9', // hide from nav panel into more ?
    [NavigationButtonPosition.STATIC]      : 'i5-panel', // like settings
}

export type ScrollToInMenu = {
    projectId?      : ID
    taskId?         : ID
    customViewId?   : ID
    userId?         : ID
    organizationId? : ID
    portfolioId?    : ID
}

export type NavigationSectionConfig = {
    id                  : ID
    icon                : string
    iconActive?         : string // when clicked
    iconSettings?       : string

    customView?         : CustomView
    personalView?       : PersonalView
    workspace?          : any
    space?              : SpaceProto

    hint?               : string
    menuComponent?      : any
    menuContent?        : any // used in asan layout

    renderComponent     : any
    onClick?            : callback

    position?           : NavigationButtonPosition // deprecated
    positionOptions?    : NavigationButtonPosition[],

    moreOptions?        : callback   // func ? - it is deprecated see positionOptions (!)

    sortPosition?       : number
    url?                : string

    _hintButtons?      : any
    hintButtons?       : any // ???? component ! ?
    keyboardShortcut?  : string

    // last becuase of hint
    name?              : string     // why we have name ? we yuse hint
    type               : NavigationSectionType
}
